import moment from "moment";

export const PORTAL_DATE_FORMAT = "DD/MM/YYYY";
export const PORTAL_DATETIME_FORMAT = "DD/MM/YYYY h:mm A";

const PARSE_FORMATS = [
  moment.ISO_8601,
  "YYYY-MM-DD HH:mm:ss",
  "YYYY-MM-DD",
  "DD/MM/YYYY HH:mm:ss",
  "DD/MM/YYYY h:mm A",
  "DD/MM/YYYY",
  "D/M/YYYY",
  "MM/DD/YYYY h:mm A",
  "MM/DD/YYYY",
  "M/D/YYYY",
];

function parsePortalMoment(value) {
  const raw = String(value ?? "").trim();
  if (!raw || raw === "—") {
    return null;
  }

  const strict = moment(raw, PARSE_FORMATS, true);
  if (strict.isValid()) {
    return strict;
  }

  const loose = moment(raw);
  return loose.isValid() ? loose : null;
}

/** Display dates as Australian DD/MM/YYYY across the customer portal. */
export function formatPortalDate(value) {
  const raw = String(value ?? "").trim();
  if (!raw || raw === "—") {
    return raw;
  }

  const parsed = parsePortalMoment(raw);
  return parsed ? parsed.format(PORTAL_DATE_FORMAT) : raw;
}

export function formatPortalDateTime(value) {
  const raw = String(value ?? "").trim();
  if (!raw || raw === "—") {
    return raw;
  }

  const parsed = parsePortalMoment(raw);
  return parsed ? parsed.format(PORTAL_DATETIME_FORMAT) : raw;
}
